export const ACCESS_TOKEN_KEY = "access_token";

export const getToken = () => {
  return window.localStorage.getItem(ACCESS_TOKEN_KEY);
};

const parts = window.location.host.split(".");
parts[0] = "api";
export const URL =
  process.env.NODE_ENV === "development"
    ? "/api"
    : `${window.location.protocol}//${parts.join(".")}`;

export const headers = {
  charset: "utf-8",
};

export const downloadLink = (id) => `${URL}/files/${id}/download`;
